import 'sass/app.scss';
import 'client/init-amplify';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import * as stores from 'client/shared/stores';
import {createBrowserHistory} from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

import Loading from './components/loading';
import MembersRoot from './components/members-root';

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();
const history = syncHistoryWithStore(browserHistory, routingStore);

ReactDOM.render(
	<Provider
		{ ...stores }
		history={ history }
		routingStore={ routingStore }
	>
		<Loading>
			<MembersRoot />
		</Loading>
	</Provider>,
	document.getElementById('app')
);
